const coursesData = {
        // all data is placeholder
    items: [
        {
          isActive: true,
          Course_number: '1/1',
          Current_stop: 'Katowice Aleja Korfantego',
            showStopDetails: false,
            nextStop: 'Main St',
            allTrips: [
              { tripName: '1	Katowice Aleja Korfantego	1/101	05:31 - 06:30', isSelected: false },
              { tripName: '1	Tychy Szpital Wojewódzki	1/102	06:32 - 07:25', isSelected: false },
              { tripName: '1	Katowice Aleja Korfantego	1/103	08:01 - 09:00', isSelected: false },
              { tripName: '1	Tychy Szpital Wojewódzki	1/104	09:02 - 09:55', isSelected: false },
              { tripName: '1	Katowice Aleja Korfantego	1/105	10:31 - 11:30', isSelected: false },
              { tripName: '1	Tychy Szpital Wojewódzki	1/106	11:32 - 12:25', isSelected: false },
              { tripName: '1	Katowice Aleja Korfantego	1/107	13:01 - 14:00', isSelected: false },
              { tripName: '1	Tychy Szpital Wojewódzki	1/108	14:02 - 14:56', isSelected: false },
              { tripName: '1	Katowice Aleja Korfantego	1/109	15:31 - 16:30', isSelected: false },
              { tripName: '1	Tychy Szpital Wojewódzki	1/110	16:32 - 17:26', isSelected: false },
              { tripName: '1	Katowice Aleja Korfantego	1/111	17:51 - 18:50', isSelected: false },
              { tripName: '1	Tychy Szpital Wojewódzki	1/112	18:52 - 19:42', isSelected: false },
            ],
            showRouteDetails: false,
            tripStops: [
                { tripStop: 'Secondary St', isSelected: false },
              { tripStop: 'Main St', isSelected: false },
              { tripStop: '3 St', isSelected: false },
              { tripStop: '4 St', isSelected: false },
              { tripStop: '5 St', isSelected: false },
              { tripStop: '6 St', isSelected: false },],
          },
          {
            isActive: true,
            Course_number: '1/2',
            Current_stop: '	Katowice Aleja Korfantego',
            showStopDetails: false,
            nextStop: 'Tychy Szpital Wojewódzki',
            allTrips: [
              { tripName: '1	Katowice Aleja Korfantego	04:28 - 05:25', isSelected: false },
              { tripName: '1	Tychy Szpital Wojewódzki	05:27 - 06:19', isSelected: false },
            ],
            showRouteDetails: false,
            tripStops: [
                { tripStop: '55 St', isSelected: false },
              { tripStop: '55 St', isSelected: false },
              { tripStop: '66 St', isSelected: false },
              { tripStop: '477 St', isSelected: false },
              { tripStop: '88 St', isSelected: false },
              { tripStop: '6345 St', isSelected: false },],
          },
          {
            isActive: true,
            Course_number: 60,
            Current_stop: 'Primary St',
            showStopDetails: false,
            nextStop: 'Main St',
            allTrips: [
              { tripName: 'placeholder for 2nd', isSelected: false },
              { tripName: 'placeholder for 2nd St', isSelected: false },
              { tripName: '3 placeholder for 2nd', isSelected: false },
              { tripName: '4 placeholder for 2nd', isSelected: false },
              { tripName: '5 placeholder for 2nd', isSelected: false },
              { tripName: '6 placeholder for 2nd', isSelected: false },
            ],
            showRouteDetails: false,
            tripStops: [
                { tripStop: '55 St', isSelected: false },
              { tripStop: '55 St', isSelected: false },
              { tripStop: '66 St', isSelected: false },
              { tripStop: '477 St', isSelected: false },
              { tripStop: '88 St', isSelected: false },
              { tripStop: '6345 St', isSelected: false },],
          },
          {
            isActive: true,
            Course_number: 70,
            Current_stop: 'Primary St',
            showStopDetails: false,
            nextStop: 'Main St',
            allTrips: [
              { tripName: 'placeholder for 2nd', isSelected: false },
              { tripName: 'placeholder for 2nd St', isSelected: false },
              { tripName: '3 placeholder for 2nd', isSelected: false },
              { tripName: '4 placeholder for 2nd', isSelected: false },
              { tripName: '5 placeholder for 2nd', isSelected: false },
              { tripName: '6 placeholder for 2nd', isSelected: false },
            ],
            showRouteDetails: false,
            tripStops: [
                { tripStop: '55 St', isSelected: false },
              { tripStop: '55 St', isSelected: false },
              { tripStop: '66 St', isSelected: false },
              { tripStop: '477 St', isSelected: false },
              { tripStop: '88 St', isSelected: false },
              { tripStop: '6345 St', isSelected: false },],
          },
          //
        ],
}

export default coursesData;
